var isArrayLikeObject = require('./isArrayLikeObject');

/**
 * Casts `value` to an empty array if it's not an array like object.
 *
 * @private
 * @param {*} value The value to inspect.
 * @returns {Array|Object} Returns the cast array-like object.
 */
function castArrayLikeObject(value) {
  return isArrayLikeObject(value) ? value : [];
}

module.exports = castArrayLikeObject;



/*****************
 ** WEBPACK FOOTER
 ** ./~/lodash/_castArrayLikeObject.js
 ** module id = 1088
 ** module chunks = 0
 **/